import { HttpClient } from '@angular/common/http';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BasePageComponent } from '@app/abstracts/base-page/base-page.component';
import {
	AttestationFinDeFormation,
	AttestationFinDeFormationService,
} from '@app/models/attestation-fin-de-formation';
import { DocumentAdministrative } from '@app/models/document-administrative';
import { Formation, FormationService } from '@app/models/formation';

import { PageInterface, PageService } from '@app/services/page.service';
import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
	selector: 'app-molecule-stagiaire-attestation-fin-formation',
	templateUrl:
		'./molecule-stagiaire-attestation-fin-formation.component.html',
	styleUrls: [
		'./molecule-stagiaire-attestation-fin-formation.component.less',
	],
})
export class MoleculeStagiaireAttestationFinFormationComponent
	extends BasePageComponent
	implements OnInit, OnDestroy
{
	private unsubscribe$ = new Subject<void>();
	formation: Formation;
	attestationFinFormation: AttestationFinDeFormation;
	document: DocumentAdministrative;
	documents: DocumentAdministrative[] = [];

	loading = false;

	constructor(
		protected pageService: PageService,
		protected translate: TranslateService,
		protected formationService: FormationService,
		protected attestationFinFormationService: AttestationFinDeFormationService,
		private route: ActivatedRoute,
		private http: HttpClient,
		private router: Router
	) {
		super(pageService, translate);
	}

	async ngOnInit() {
		super.ngOnInit();
		this.loading = true;
		try {
			await this.getFormationInfos();
			await this.getAttestationFinFormation();
		} catch (error) {
			console.error('Error fetching attestation fin formation:', error);
			this.router.navigate(['/']);
		} finally {
			this.loading = false;
		}
	}

	ngOnDestroy() {
		super.ngOnDestroy();
		this.unsubscribe$.next();
		this.unsubscribe$.complete();
	}

	async getFormationInfos() {
		this.formation = await this.formationService.get(
			this.route.snapshot.params.formationId
		);
	}

	getPageData(): PageInterface {
		return {
			title: this.translate.instant(
				'page_title-formation_attestation_fin_formation',
				{
					formation: this.formation ? this.formation.getLabel() : '',
				}
			),
			hideTopBar: true,
			hideMenu: true,
		};
	}

	async getAttestationFinFormation() {
		try {
			this.attestationFinFormation =
				await this.attestationFinFormationService.get(
					this.route.snapshot.params.attestationId,
					{
						_populate: ['document'],
					}
				);

			if (
				this.attestationFinFormation &&
				this.attestationFinFormation.documentExists()
			) {
				this.document = this.attestationFinFormation.props
					.document as DocumentAdministrative;
				// Create an array with just this document for the document table component
				this.documents = [this.document];
			}
		} catch (error) {
			console.error('Error fetching attestation fin formation:', error);
		}
	}

	async handleClick() {
		try {
			const { url } =
				await this.formationService.getPresignedAttestationFinFormation(
					this.formation.getId(),
					this.attestationFinFormation.getId()
				);
			window.open(url, '_blank');
		} catch (error) {
			console.error('Error opening document:', error);
		}
	}

	downloadPdf(url: string, filename: string) {
		this.http
			.get(url, { responseType: 'blob' })
			.pipe(takeUntil(this.unsubscribe$))
			.subscribe(
				(response) => {
					const file = new Blob([response], { type: response.type });

					const fileURL = URL.createObjectURL(file);
					const fakeDownload = document.createElement('a');
					fakeDownload.href = fileURL;
					fakeDownload.target = '_blank';
					fakeDownload.download = filename;
					document.body.appendChild(fakeDownload);
					fakeDownload.click();
					URL.revokeObjectURL(fileURL);
					fakeDownload.remove();
				},
				(error) => {
					console.error('Error downloading document:', error);
				}
			);
	}

	async handleDownload(event: { idDoc: string; filename: string }) {
		try {
			const { url } =
				await this.formationService.getPresignedAttestationFinFormation(
					this.formation.getId(),
					this.attestationFinFormation.getId()
				);
			this.downloadPdf(url, event.filename);
		} catch (error) {
			console.error('Error downloading document:', error);
		}
	}
}
